module.exports = __webpack_public_path__ + "static/media/Process_flow_white_background_v2.471f2966.png";